import { toast } from "react-toastify";
import {
  ShowMessagesContainer,
  MessageSearchContainer,
} from "../components/messages";
import { useLoaderData } from "react-router-dom";
import { customFetch } from "../utils/custom-fetch.js";
import { useContext, createContext } from "react";
import { useNavigate } from "react-router-dom";

export const loader = async ({ request }) => {
  const params = Object.fromEntries([
    ...new URL(request.url).searchParams.entries(),
  ]);

  try {
    const { data } = await customFetch.get("/messages/global", { params });
    const companies = await customFetch.get("/buildings/maintenance-companies");
    
    const maintenanceCompanies = [
      ...companies.data.map((company) => ({
        name: company.name,
        _id: company.value,
      })),
    ];

    return { data, maintenanceCompanies };
  } catch (error) {
    toast.error(error?.response?.data?.msg || "שגיאה בטעינת ההודעות");
    return error;
  }
};

const AllMessagesContext = createContext();

const ShowMessages = () => {
  const { data, maintenanceCompanies  } = useLoaderData();
  const navigate = useNavigate();
  return (
    <AllMessagesContext.Provider value={{ data,maintenanceCompanies }}>
      <button
        type="button"
        style={{ marginBottom: "1rem" }}
        className="btn btn-primary"
        onClick={() => navigate("/dashboard/all-messages")}
      >
        צור הודעה חדשה
      </button>
      <MessageSearchContainer />
      <ShowMessagesContainer />
    </AllMessagesContext.Provider>
  );
};

export const useAllMessagesContext = () => useContext(AllMessagesContext);

export default ShowMessages;
